<template>
  <div class="vip-banner">
    <img class="banner-background" :src="vipBackground" />
    <div class="vip-body flex" :class="{ 'col-stretch': inVip }">
      <!-- 头像 -->
      <preview-image class="m-r-24" size="72px" :file-id="face" around />
      <!-- 会员信息 -->
      <div class="vip-info">
        <div class="vip-info-name">
          <div class="flex-1 flex col-center">
            <span>{{ nickname || '-' }}</span>
            <img
              v-if="inVip"
              style="width: 94px; margin-left: 6px"
              :src="vipTag"
              alt=""
            />
          </div>
          <div
            v-if="inVip"
            class="customer-service-tag"
            @click="customerServiceDialog = true"
          >
            <img
              style="width: 18px; height: 18px"
              :src="
                require('@/assets/images/personal-center/vip-home/icon-customer-service.png')
              "
              alt=""
            />
            专属客服
          </div>
        </div>
        <div class="vip-info-desc-wrap">
          <div class="vip-info-desc">
            <span class="vip-info-desc_label">企业名称：</span>
            <span class="vip-info-desc_content">
              {{ companyName || '-' }}
            </span>
          </div>
          <div v-if="inVip" class="vip-info-desc">
            <span class="vip-info-desc_label">CA领取状态：</span>
            <span class="vip-info-desc_content">
              {{ caVoucher > 0 ? '未领取' : '已领取' }}
            </span>
            <a-button
              v-if="caVoucher"
              type="link"
              style="height: auto"
              @click="toCACenter"
            >立即领取</a-button>
          </div>
        </div>
        <div v-if="inVip" class="ca-tip">
          CA领取状态仅作为您是否已使用会员附赠的CA数字证书抵扣券的提示，CA是否绑定贵司相关主体，请与客服或贵司同事确认。
        </div>
      </div>
      <!-- 开通会员 -->
      <div v-if="!inVip" class="open-vip">
        <div class="open-vip-tip">加入标前狗会员，获得百万专属商机</div>
        <a-button class="open-vip-button" @click="openVip">{{
          openVipName
        }}</a-button>
      </div>
    </div>

    <!-- 客服企业微信二维码弹窗 -->
    <a-modal
      v-model="customerServiceDialog"
      title="客服二维码"
      :mask-closable="false"
      :footer="null"
      :width="300"
    >
      <div class="flex row-center">
        <img
          style="width: 220px; height: 220px"
          :src="customerServiceQrCodeUrl"
          alt=""
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
// 接口
import PreviewImage from '@/components/Upload/PreviewImage'
// vuex
import { mapGetters, mapState } from 'vuex'
// 字典
import { valueAddedProductCodeDict } from '@/dictionary/value-added-service'
// 接口
import { getBasicSetupApi } from '@/api/user'

export default {
  name: 'VipBanner',

  components: { PreviewImage },

  data() {
    return {
      customerServiceDialog: false,
      // 客服企业微信二维码
      customerServiceQrCodeUrl:
        process.env.VUE_APP_OSS_URL + '/portal/static/image/kefu_1.jpg'
    }
  },

  computed: {
    ...mapState('user', ['vipInfo', 'vipBalance', 'nickname', 'face']),
    ...mapState('company', ['companyName']),
    ...mapGetters('user', ['inVip']),

    vipBackground() {
      const alias =
        valueAddedProductCodeDict.translate(
          this.vipInfo?.productInfo?.productCode
        )?.alias || ''
      const pngName = alias ? 'vip-banner' + `-${alias}` : 'vip-banner'
      return require(`@/assets/images/personal-center/vip-home/${pngName}.png`)
    },

    vipTag() {
      const alias =
        valueAddedProductCodeDict.translate(
          this.vipInfo?.productInfo?.productCode
        )?.alias || ''
      const pngName = alias ? 'vip-tag' + `-${alias}` : 'vip-tag'
      return require(`@/assets/images/personal-center/vip-home/${pngName}.png`)
    },

    // CA抵扣券数量
    caVoucher() {
      return (
        this.vipBalance[
          valueAddedProductCodeDict.DIGITAL_CERTIFICATE_VOUCHER.value
        ]?.remain || 0
      )
    },

    // 开通会员按钮名称
    openVipName() {
      if (this.vipInfo.rightsId && this.vipInfo.isExpire) {
        return '续费会员'
      }
      return '开通会员'
    }
  },

  methods: {
    /**
     * 开通会员
     */
    openVip() {
      const url = process.env.VUE_APP_PORTAL_URL + '/value-added/vip/buy'
      window.open(url, '_self')
    },

    /**
     * 前往CA中心领取CA
     */
    toCACenter() {
      const url = process.env.VUE_APP_LOGIN_JUMP_URL + '/services/ca/buy'
      window.open(url, '_self')
    }
  }
}
</script>

<style lang="scss" scoped>
.vip-banner {
  width: 100%;
  height: 128px;
  position: relative;
  box-sizing: border-box;
  padding: 20px 24px;
  margin-bottom: 16px;

  .banner-background {
    width: 100%;
    height: 128px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }

  .vip-body {
    .vip-info {
      flex: 1;

      .vip-info-name {
        font-size: 20px;
        color: $text-color;
        margin-bottom: 14px;
        display: flex;
        align-items: center;
        @include text-bold;

        .customer-service-tag {
          font-size: 14px;
          background-color: rgba(255, 255, 255, 0.6);
          border-radius: 4px;
          padding: 4px 8px;
          cursor: pointer;
          font-weight: normal;
        }
      }

      .vip-info-desc {
        display: inline-block;
        &:not(:last-child) {
          margin-right: 64px;
        }

        .vip-info-desc_label {
          color: $text-third-color;
        }

        .vip-info-desc_content {
          color: $text-color;
        }
      }

      .ca-tip {
        font-size: 12px;
        color: $text-third-color;
        margin-top: 20px;
      }
    }

    .open-vip {
      text-align: right;

      .open-vip-tip {
        color: $text-color;
        margin-bottom: 10px;
      }

      .open-vip-button {
        color: $member-second-color;
        background-color: #fcdd9f;

        &.ant-btn:hover,
        &.ant-btn:focus {
          border-color: #fcdd9f;
        }
      }
    }
  }
}
</style>
